import type { ReactNode } from 'react';
import { Center, Loader, Stack, Text, ThemeIcon } from '@mantine/core';
import {
  IconAlertCircle,
  IconDatabaseOff,
  IconLock,
} from '@tabler/icons-react';
import {
  getLoadErrorMessage,
  getResponseStatus,
} from '#/service/driver-management/utils/apiError.ts';

type SectionMessageProps = {
  icon?: ReactNode;
  color?: string;
  children: ReactNode;
};

const SectionMessage = ({
  icon = <IconDatabaseOff size={18} />,
  color = 'gray',
  children,
}: SectionMessageProps) => (
  <Stack align="center" gap="xs" py="md">
    <ThemeIcon variant="light" color={color} radius="xl" size="lg">
      {icon}
    </ThemeIcon>
    <Text size="sm" c={color === 'gray' ? 'dimmed' : color} ta="center">
      {children}
    </Text>
  </Stack>
);

type SectionStateProps =
  | { status: 'loading' }
  | { status: 'empty'; message: string }
  | { status: 'error'; error: Error };

const SectionState = (props: SectionStateProps) => {
  switch (props.status) {
    case 'loading':
      return (
        <Center py="xl">
          <Loader size="sm" />
        </Center>
      );
    case 'empty':
      return <SectionMessage>{props.message}</SectionMessage>;
    case 'error':
      return getResponseStatus(props.error) === 403 ? (
        <SectionMessage icon={<IconLock size={18} />} color="orange">
          {getLoadErrorMessage(props.error)}
        </SectionMessage>
      ) : (
        <SectionMessage icon={<IconAlertCircle size={18} />} color="red">
          {getLoadErrorMessage(props.error)}
        </SectionMessage>
      );
  }
};

export { SectionState };
